<template>
  <v-layout column>
    <v-flex xs12>
      <v-layout align-center>
        <v-flex shrink>
          <AppLogo
            :width="60"
            :url="data.redirect"
          />
        </v-flex>
        <v-flex
          shrink
          :ml-4="$vuetify.breakpoint.mdAndUp"
          :ml-2="$vuetify.breakpoint.smAndDown"
        >
          <h1 class="display-4">
            {{ data.title }}
          </h1>
          <h2 class="display-3 hidden-xs-only">
            {{ data.subtitle }}
          </h2>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';
export default {
    name: 'AddFamilyTemplateHeader',
    components: { AppLogo },
    props: ['data']
};
</script>

<style scoped></style>
